import { EnumPromocaoTipoRegra } from "model/enums/enum-promocao-tipo-regra";

export class PromocaoRegraModeloModel {
    public constructor(public promocaoId: string, public tipo: EnumPromocaoTipoRegra, public nome: string, public detalhe: string, public status: string, public qtdRegras: number) { }
}